import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rejectPost } from '../services/moderation';
import { moderationQueryKeys } from './query-keys';

export const useRejectPostMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ postId, reason }) => {
      const result = await rejectPost(postId, reason);
      if (!result.success) {
        throw new Error(result.message || 'Failed to reject post');
      }
      return result.data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: moderationQueryKeys.queue() });
      if (options.onSuccess) {
        options.onSuccess(...args);
      }
    },
    ...options,
  });
};
